// extracted by mini-css-extract-plugin
export default {"container":"style_container__KoW89","header":"style_header__zPg5l","title":"style_title__0gxDm","child":"style_child__AyI4n"};